<script setup>
defineProps({
  block: {
    type: Object,
    default: () => ({}),
  },
})
</script>

<template>
  <div class="double-block">
    <div class="section-double-block max">
      <img
        src="@/assets/img/first.png"
        class="first-image"
        alt="Istituto Canossiano"
      />
      <img
        src="@/assets/img/second.png"
        class="second-image"
        alt="Istituto Canossiano"
      />
      <!-- eslint-disable vue/no-v-html -->
      <div v-if="block.cards.length" class="container">
        <div v-for="card in block.cards" :key="card.id" class="card">
          <div class="content">
            <div
              v-if="card.titolo"
              class="card-title title-base1"
              v-html="card.titolo"
            />
            <div
              v-if="card.sottotitolo"
              class="card-subtitle text-s-1-b"
              v-html="card.sottotitolo"
            />
            <div
              v-if="card.testo"
              class="card-text text-s-1-b"
              v-html="card.testo"
            />
            <div class="link-container">
              <div v-for="cta in card.cta" :key="cta.id">
                <DefaultLink
                  v-if="cta"
                  class="icon-link text-custom is-semi-bold"
                  :text="cta.testo"
                  :content="cta.link"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DoubleBlockCards',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
